export default "__VITE_ASSET__DczxLp4G__"